import * as types from "../types/heldOrders"

const initialState = []

const foodsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_HELD_ORDER:
      return [action.order, ...state]
    case types.DELETE_ALL_HELD_ORDERS:
      return []
    case types.DELETE_HELD_ORDER:
      return state.filter(heldOrder =>
        heldOrder._id !== action.heldOrderId
      )
    default:
      return state
  }
}

export default foodsReducer